import { RowProps } from "../types";
import { TableCell, TableRow } from "@mui/material";
import DownloadFileButton from "./DownloadFileButton";
import TableCellWithHover from "./TableCellWithHover";
import { styleMapper } from "../map/styles";
import {
  formatShortDate,
  formatShortDateTime,
  formatDisplayValue,
} from "../map/information-cards/formatting";

const isSameIncident = (
  firstRow: RowProps["row"],
  secondRow: RowProps["row"],
) => {
  return (
    firstRow.incidentsId === secondRow.incidentsId &&
    firstRow.scannedAt === secondRow.scannedAt
  );
};

export const Row = ({
  row,
  solutionId,
  selectedIncidents,
  setSelectedIncident,
  setSelectedIncidents,
}: RowProps) => {
  const isSelected = selectedIncidents.some((selectedRow) =>
    isSameIncident(selectedRow, row),
  );

  return (
    <TableRow
      hover
      selected={isSelected}
      onClick={() => {
        setSelectedIncidents((previousSelectedIncidents) => {
          const isAlreadySelected = previousSelectedIncidents.some(
            (selectedRow) => isSameIncident(selectedRow, row),
          );

          if (isAlreadySelected) {
            const nextSelectedIncidents = previousSelectedIncidents.filter(
              (selectedRow) => !isSameIncident(selectedRow, row),
            );
            const nextSelectedIncident =
              nextSelectedIncidents[nextSelectedIncidents.length - 1] ?? null;
            setSelectedIncident(nextSelectedIncident);
            return nextSelectedIncidents;
          }

          setSelectedIncident(row);
          return [...previousSelectedIncidents, row];
        });
      }}
      sx={{
        cursor: "pointer",
        ...(isSelected
          ? {
              backgroundColor: styleMapper[row.type].background,
              "&.Mui-selected": {
                backgroundColor: styleMapper[row.type].background,
              },
              "&.Mui-selected:hover": {
                backgroundColor: styleMapper[row.type].background,
              },
            }
          : {}),
      }}
    >
      <TableCell align="left">{row.incidentsId}</TableCell>
      <TableCell align="left">
        {formatShortDate(row.scannedAt) ?? "N/A"}
      </TableCell>
      <TableCellWithHover
        align={"center"}
        name={formatDisplayValue(row.type)}
        incidentInfo={{
          type: row.type,
          category: "type",
        }}
      />
      <TableCellWithHover
        align="center"
        name={formatShortDateTime(row.incidentSpecificTime) ?? "N/A"}
        incidentInfo={{
          type: row.type,
          category: "time",
        }}
      />

      <TableCell align="center">
        {formatDisplayValue(row.boundaryBufferKm)}
      </TableCell>

      <TableCellWithHover
        align={"center"}
        name={formatDisplayValue(row.areaM2)}
        incidentInfo={{
          type: row.type,
          category: "area",
        }}
      />

      <TableCell align="center" onClick={(event) => event.stopPropagation()}>
        <DownloadFileButton solutionId={solutionId} row={row} />
      </TableCell>
    </TableRow>
  );
};
